module.exports = __webpack_public_path__ + "static/img/icon_zj_02.7d6d5901.png";